// src/ui/shell/ActingAs.tsx (T1): "Reacting as Dana · Switch to Chris". One shared phone or laptop, two people:
// the pill in the desktop top bar (and inside sheets), the compact switch in the phone top bar. Shown only when
// the viewer can act as someone else (spec 2.10, snapshot.viewer.canActAs). Root class: hb-acting-as.
import { Avatar, type AvatarTone } from "../Avatar";
import { cx } from "../cx";
import { Icon } from "../Icon";

export type ActingPerson = { firstName: string; initials: string; tone: AvatarTone };
export type ActingAsProps = {
  current: ActingPerson;
  /** Who a tap switches to. */
  next: ActingPerson;
  onSwitch: () => void;
  /** "Reacting" everywhere; "Adding" on Sort. */
  verb?: "Reacting" | "Adding";
};

function aria(p: ActingAsProps): string {
  return `${p.verb ?? "Reacting"} as ${p.current.firstName}. Switch to ${p.next.firstName}`;
}

/** The pill: desktop top bar, or `inline` inside a page or sheet (hidden on phone outside sheets). */
export function ActingAsPill(props: ActingAsProps & { inline?: boolean; class?: string }) {
  return (
    <button type="button" class={cx("hb-acting-as", "as-pill", props.inline && "as-inline", props.class)} aria-label={aria(props)} onClick={props.onSwitch}>
      <Avatar initials={props.current.initials} tone={props.current.tone} size="xs" />
      <span class="as-txt">
        {props.verb ?? "Reacting"} as <b>{props.current.firstName}</b>
      </span>
      <span class="as-sw">Switch to {props.next.firstName}</span>
    </button>
  );
}

/** The phone top bar's switch: avatar, name, swap icon (the verb is visually hidden under 600px). */
export function ActingAsSwitch(props: ActingAsProps) {
  return (
    <button type="button" class="hb-acting-as mtop-as" aria-label={aria(props)} onClick={props.onSwitch}>
      <Avatar initials={props.current.initials} tone={props.current.tone} size="sm" />
      <span class="mas-t">
        <span class="mas-v">{props.verb ?? "Reacting"} as </span>
        <b>{props.current.firstName}</b>
      </span>
      <Icon name="swap" size="sm" />
    </button>
  );
}
